<template>
  <div class="product-item-box">
    <ul class="product-item-wrap" v-if="carLists && carLists.length > 0">
      <van-swipe-cell
        :right-width="65"
        :on-close="onClose"
        v-for="(item, index) in carLists"
        :key="index"
      >
        <li class="product-item">
          <!--多选框 ,商品图片，商品名，套餐选择 -->
          <div class="product-dsc">
            <van-checkbox
              class="product-item-check"
              :name="item"
              checked-color="#d5503f"
              v-model="item.isCheck"
              @change="seleteItem(index)"
            ></van-checkbox>
            <!-- 图片 -->
            <span class="product-item-pic dg-small-no-photo">
              <img :src="item.comImageCar" alt v-if="item.comImageCar">
            </span>
            <div class="product-item-info">
              <p class="product-item-title">{{item.comName || '未知'}}</p>
              <!-- 套餐选择 -->
              <div class="setmeat-box">
                <div
                  class="product-setmeat"
                  @click="showPopup(item,index)"
                  v-for="(attr, attrIndex) in item.attributeCar"
                  :key="attrIndex"
                >
                  <p class="product-setmeat-text">{{attr.name + ':' + attr.value}}</p>
                </div>
              </div>
              <!-- 价格，数量选择 -->
              <div class="product-calculate">
                <p class="product-item-price">
                  <span class="fs24">JPY</span>
                  {{item.price}}
                </p>
                <div class="stepper">
                  <van-stepper
                    v-model="item.count"
                    :min="1"
                    :max="999"
                    @plus="getNowNumber(item, index,'plus')"
                    @minus="getNowNumber(item, index, 'minus')"
                    @change="getNowNumber(item, index, 'blur')"
                  />
                </div>
              </div>
            </div>
          </div>
        </li>
        <span slot="right" class="delete-cell" @click="deleteCartItem(item,index)">删除</span>
      </van-swipe-cell>
    </ul>
    <div class="dg-no-car-data" v-else>购物车空空如也～</div>

    <!-- 底部合计结算 -->
    <div class="count-wrap" v-if="carLists.length > 0">
      <van-checkbox
        class="count-wrap-checkbox"
        checked-color="#d5503f"
        v-model="allCheckeds"
        @click="allChecked"
      >全选</van-checkbox>
      <div class="settlement" v-show="settlementShow">
        <div class="settlement-total">
          <p class="amount-p">合计:</p>
          <p class="amount-num">
            <span class="fs24">JPY</span>
            {{sumPrice}}
          </p>
        </div>
        <button class="settlement-total-btn" @click="createOrder">结算 ({{checkedNumber}}）</button>
      </div>
      <!-- 点击编辑后，结算金额隐藏，删除按钮显示 -->
      <button class="car-detet-btn" v-show="fullDetetShow" @click="batchDelete">删除</button>
    </div>
  </div>
</template>
<script>
import api from "@/server";
export default {
  data() {
    return {
      loading: false,
      finished: false,
      value: 1,
      // 全选状态
      allCheckeds: false,
      //选中的商品列表，用于计算总价
      checkList: [],
      // 删除操作参数
      deleteParams: {
        cartIdList: []
      },
      // 添加临时订单参数
      orderParams: {
        cartList: [],
        userId: localStorage.getItem("userInfo")
          ? JSON.parse(localStorage.getItem("userInfo"))._id
          : "",
        payType: "1",
        remark: "",
        totalCost: "",
        tempOrderNumber: "",
        type: "TEMP",
        buyType: 1,
        join: 0
      },
      carLists: this.carList,
      // 计算总价格
      sumPrice: 0,
      // 选中的个数
      checkedNumber: 0
    };
  },
  props: ["carList", "settlementShow", "fullDetetShow"],
  activated() {
    this.sumPrice = 0;
    this.checkedNumber = 0;
  },
  deactivated() {
    this.allCheckeds = false;
  },
  methods: {
    // 全选、全部不选
    allChecked() {
      this.carLists.map(item => {
        if (this.allCheckeds) {
          return (item.isCheck = true);
        } else {
          return (item.isCheck = false);
        }
      });
      this.getSumPrice();
    },
    // 单选、取消单选
    seleteItem() {
      let itemisChecked = [];
      this.carLists.forEach(function(item) {
        if (item.isCheck) {
          itemisChecked.push(item);
        }
      });
      this.checkedNumber = itemisChecked.length;
      if (itemisChecked.length === this.carLists.length) {
        this.allCheckeds = true;
      } else {
        this.allCheckeds = false;
      }
      this.getSumPrice();
    },
    // 批量删除购物车，提交数据库同时提交本地缓存
    batchDelete() {
      this.deleteParams.cartIdList = [];
      this.carLists.forEach(item => {
        if (item.isCheck) {
          this.deleteParams.cartIdList.push(item._id);
        }
      });
      if (this.deleteParams.cartIdList.length === 0) {
        this.$toast("请至少选择一件商品");
      } else {
        this.deleteFunction();
      }
    },
    // 单个删除购物车，提交数据库的同时提交本地缓存
    deleteCartItem(item) {
      this.deleteParams.cartIdList = [];
      this.deleteParams.cartIdList.push(item._id);
      this.deleteFunction();
    },
    // 删除方法
    deleteFunction() {
      api
        .deleteCar(this.deleteParams)
        .then(res => {
          if (res.code === 200) {
            this.$toast.success("删除成功");
            let carList = JSON.parse(localStorage.getItem("carList"));
            this.deleteParams.cartIdList.forEach(item => {
              carList.forEach((car, i) => {
                if (car._id === item) {
                  carList.splice(i, 1);
                }
              });
            });
            localStorage.setItem("carList", JSON.stringify(carList));
            this.$store.dispatch("setCarNumber", carList.length);
            this.carLists = carList;
            this.$emit('handlerCarList')
          }
        })
        .catch(() => {});
    },
    // 选中购物车加减时计算总价
    getNowNumber(item, index, type) {
      console.log(item.count);
      let count = "";
      if (type === "plus") {
        count = item.count + 1;
      } else if (type === "blur") {
        count = item.count;
      } else {
        count = item.count - 1;
      }
      api
        .editCar({
          id: item.id,
          count: count,
          attributeCar: item.attributeCar,
          comName: item.comName,
          price: item.price,
          comImageCar: item.comImageCar,
          commId: item.commId,
          userId: item.userId
        })
        .then(res => {
          if (res.code === 200) {
            this.getSumPrice();
            let carList = JSON.parse(localStorage.getItem("carList"));
            carList[index].count = item.count;
            localStorage.setItem("carList", JSON.stringify(carList));
          } else {
            this.$toast("数量添加失败！");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    onClose(clickPosition, instance) {
      switch (clickPosition) {
        case "right":
          instance.close();
          break;
      }
    },
    // 点击套餐弹出重新选择套餐弹框
    showPopup(item, index) {
      this.$emit("showPopups", item, index);
    },
    // 计算总价
    getSumPrice() {
      this.sumPrice = 0;
      this.carLists.forEach(item => {
        if (item.isCheck) {
          this.sumPrice += item.count * item.price;
        }
      });
    },
    // 购物车结算
    createOrder() {
      this.orderParams.cartList = [];
      this.carLists.forEach(item => {
        let production = {
          cartId: item.id,
          commId: item.commId,
          comName: item.comName,
          count: item.count,
          price: item.price,
          attribute: item.attributeCar,
          comImage: item.comImageCar
        };
        if (item.isCheck) {
          this.orderParams.cartList.push(production);
        }
      });
      this.orderParams.totalCost = this.sumPrice;
      if (this.orderParams.cartList.length === 0) {
        this.$toast("请至少选择一件商品");
      } else {
        api.createOrder(this.orderParams).then(res => {
          if (res.code === 200) {
            this.$router.push({
              name: "confirm-order",
              query: {
                id: res.data.orderNumber,
                type: "car"
              }
            });
          } else {
            this.$toast.fail("购买失败！");
          }
        });
      }
    }
  },
  watch: {
    carList: {
      handler(val) {
        this.carLists = val;
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" >
.product-item-wrap {
  width: 100%;
  height: auto;
  padding: 30px 0;
  .fs24 {
    font-size: 22px;
  }
  .van-swipe-cell {
    width: 100%;
    overflow: hidden;
  }
  // 购物车信息列表
  .product-item {
    width: calc(100% - 60px);
    margin: 0 auto;
    height: auto;
    padding: 30px 30px;
    margin-bottom: 24px;
    background: $bg02;
    border-radius: $br30;
    box-shadow: $box-shadow1;
    // 多选框 ,商品图片，商品名，套餐选择
    .product-dsc {
      width: 100%;
      display: flex;
      overflow: hidden;
      .product-item-check {
        font-size: 38px;
        margin-top: 50px;
      }
      .product-item-pic {
        width: 150px;
        height: 160px;
        border: 1px solid $bc04;
        border-radius: 20px;
        margin: 0 24px;
        overflow: hidden;
        display: inline-block;
        box-sizing: inherit;
        & img {
          width: 100%;
          height: 100%;
        }
      }
      .product-item-info {
        flex: 1;
        width: 360px;
        height: auto;
        overflow: hidden;
        .setmeat-box {
          min-height: 65px;
        }
        .product-item-title {
          font-size: 28px;
          color: $fc06;
          @include ellipsis();
          overflow: hidden;
        }
        // 套餐选择
        .product-setmeat {
          max-width: 170px;
          background: $bg01;
          padding: 6px 10px;
          margin-top: 4px;
          display: inline-block;
          justify-content: space-between;
          align-items: center;
          margin-right: 20px;
          .product-setmeat-text {
            color: $fc09;
            font-size: 24px;
            @include ellipsis();
          }
          .van-icon-arrow-down {
            font-size: 36px;
            color: $fc09;
            font-weight: 600;
          }
        }
      }
    }
    // 标题，价格，数量
    .product-calculate {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
      overflow: hidden;
      .product-item-price {
        font-size: 28px;
        color: $fc04;
        flex: 1;
      }
      .van-stepper__minus,
      .van-stepper__plus {
        width: 40px;
        height: 40px;
        border-radius: 35px;
        background: $btn01;
        color: white;
      }
      .van-stepper__minus::before,
      .van-stepper__plus::before,
      .van-stepper__minus::after,
      .van-stepper__plus::after {
        background: white;
      }
      .van-stepper__minus:active,
      .van-stepper__plus:active {
        background: $btnHover01;
      }
      .van-stepper__minus--disabled,
      .van-stepper__plus--disabled {
        background: $btnHover01;
      }
      input {
        width: 40px;
        height: 40px;
        background: none;
        font-size: 24px;
        /*font-weight: bold;*/
      }
    }
  }
  // 删除滑块
  .delete-cell {
    display: inline-block;
    width: 130px;
    height: 100%;
    background: $btn02;
    text-align: center;
    font-size: 30px;
    color: $fc02;
    border-radius: $br20;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>


